/* eslint-disable array-callback-return */
import { Button, Input, Layout, Modal, Space, message } from 'antd'
import { HeaderSection } from 'app/components/Layouts'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { IconPlus } from '@tabler/icons'
import TextArea from 'antd/es/input/TextArea'
import { useToken, useWindowDimensions } from 'app/hooks'
import API from '../../../utils/api'
import { column_usergroup } from '../../components/AdminUserModal/UserInfoTabs/column_usergroup'
import SendMessage from '../../components/SendMessage'
import TableAPI from '../../components/TableAPI'
import EnhancedUserGroupTable from '../../components/EnhancedUserGroupTable'
import GroupCardGrid from '../../components/GroupCardGrid'
import { SendModal } from '../SendModal'
import { useUserGroups } from 'app/hooks/useUserGroups'

const { Content } = Layout

const StyledLayout = styled(Layout)`
  background: #f8f9fa;
  min-height: 100vh;
`

const StyledContent = styled(Layout.Content)`
  padding: 0 50px 20px;
  background: transparent;
`

const AddGroupModal = styled(Modal)`
  .ant-modal-content {
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
  }

  .ant-modal-header {
    background: rgba(255, 255, 255, 0.03);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .ant-modal-title {
    color: #ffffff;
  }

  .ant-modal-body {
    background: transparent;
  }
`

export const AdminUserGroupPage = () => {
	const { width } = useWindowDimensions()
	const [visible, setVisible] = React.useState(false)
	const [useEnhanced, setUseEnhanced] = React.useState(false)
	const [useCardView, setUseCardView] = React.useState(true)

	const { data: token } = useToken()

	const [name, setName] = React.useState('')
	const [info_d, setInfo_d] = React.useState('')
	const [info_w, setInfo_w] = React.useState('')
	const [cs_1, setCs_1] = React.useState('')
	const [cs_2, setCs_2] = React.useState('')
	const [cs_3, setCs_3] = React.useState('')
	const [cs_4, setCs_4] = React.useState('')
	const [kor_1, setKor_1] = React.useState('')
	const [kor_2, setKor_2] = React.useState('')
	const [kor_3, setKor_3] = React.useState('')

	const [refresh, setRefresh] = React.useState(0)

	// 커스텀 Hook을 사용해서 데이터 가져오기
	const { groups: groupData, isLoading, refresh: refreshData } = useUserGroups(refresh)

	const location = useLocation()
	const url = location.pathname

	const handleRefresh = () => {
		setRefresh(prev => prev + 1)
		refreshData()
	}

	return (
		<StyledLayout>
			<Helmet>
				<title>ADMIN DASHBOARD</title>
			</Helmet>
			<HeaderSection />
			<StyledContent>
				<AddGroupModal
					title="새 그룹 추가"
					open={visible}
					footer={null}
					onCancel={() => setVisible(false)}>
					<Space direction="vertical" style={{ width: '100%' }}>
						<Input
							placeholder="그룹명"
							value={name}
							onChange={e => setName(e.target.value)}
						/>
						<TextArea
							placeholder="입금안내"
							value={info_d}
							onChange={e => setInfo_d(e.target.value)}
						/>
						<TextArea
							placeholder="출금안내"
							value={info_w}
							onChange={e => setInfo_w(e.target.value)}
						/>
						<Input
							placeholder="고객센터1"
							value={cs_1}
							onChange={e => setCs_1(e.target.value)}
						/>
						<Input
							placeholder="고객센터2"
							value={cs_2}
							onChange={e => setCs_2(e.target.value)}
						/>
						<Input
							placeholder="텔레상담링크"
							value={cs_3}
							onChange={e => setCs_3(e.target.value)}
						/>
						<Input
							placeholder="카톡상담링크"
							value={cs_4}
							onChange={e => setCs_4(e.target.value)}
						/>
						<Input
							placeholder="은행명"
							value={kor_1}
							onChange={e => setKor_1(e.target.value)}
						/>
						<Input
							placeholder="계좌번호"
							value={kor_2}
							onChange={e => setKor_2(e.target.value)}
						/>
						<Input
							placeholder="예금주"
							value={kor_3}
							onChange={e => setKor_3(e.target.value)}
						/>
						<Button
							type="primary"
							onClick={() => {
								if (name == '') {
									message.error('그룹명을 입력해주세요')
									return
								}

								API.post(`/admin/usergroup`, token + '', {
									name,
									info_d,
									info_w,
									cs_1,
									cs_2,
									cs_3,
									cs_4,
									kor_1,
									kor_2,
									kor_3,
								}).then(res => {
									message.success('그룹이 추가되었습니다.')
									setVisible(false)
									handleRefresh()
									// Clear form
									setName('')
									setInfo_d('')
									setInfo_w('')
									setCs_1('')
									setCs_2('')
									setCs_3('')
									setCs_4('')
									setKor_1('')
									setKor_2('')
									setKor_3('')
								})
							}}>
							그룹추가
						</Button>
					</Space>
				</AddGroupModal>

				{/* 임시로 TableAPI 다시 활성화해서 API 확인 */}
				<div style={{ display: 'none' }}>
					<TableAPI
						title={'회원그룹목록'}
						columns={column_usergroup}
						usermodal={false}
						height={false}
						pagination={true}
						defaultMaxData={50}
						apikey={`/admin/usergroup?t=${refresh}`}
					/>
				</div>

				{useCardView ? (
					<GroupCardGrid
						groups={groupData}
						loading={isLoading}
						onDataChange={handleRefresh}
						onAddGroup={() => setVisible(true)}
					/>
				) : useEnhanced ? (
					<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
							<h1 style={{ color: '#ffffff', margin: 0, fontSize: 24, fontWeight: 600 }}>
								회원그룹목록
							</h1>
							<Space>
								<Button
									type="primary"
									icon={<IconPlus />}
									onClick={() => setVisible(true)}
									style={{
										background: 'linear-gradient(45deg, #667eea, #764ba2)',
										border: 'none',
										borderRadius: 8
									}}
								>
									그룹추가
								</Button>
								<SendMessage target="all" targetid="all" />
								<Button
									size="small"
									onClick={() => setUseCardView(true)}
									style={{
										background: 'rgba(255,255,255,0.1)',
										border: '1px solid rgba(255,255,255,0.2)',
										color: '#ffffff'
									}}
								>
									카드 보기
								</Button>
								<Button
									size="small"
									onClick={() => setUseEnhanced(false)}
									style={{
										background: 'rgba(255,255,255,0.1)',
										border: '1px solid rgba(255,255,255,0.2)',
										color: '#ffffff'
									}}
								>
									기본 테이블
								</Button>
							</Space>
						</div>
						<EnhancedUserGroupTable
							dataSource={groupData}
							onDataChange={handleRefresh}
							loading={isLoading}
						/>
					</div>
				) : (
					<div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
							<h2 style={{ color: '#ffffff', margin: 0 }}>회원그룹목록 (기본 테이블)</h2>
							<Space>
								<Button
									size="small"
									icon={<IconPlus />}
									onClick={() => setVisible(true)}
									style={{
										background: 'rgba(255,255,255,0.1)',
										border: '1px solid rgba(255,255,255,0.2)',
										color: '#ffffff'
									}}
								>
									그룹추가
								</Button>
								<SendMessage target={'all'} targetid={'all'} />
								<Button
									size="small"
									onClick={() => setUseCardView(true)}
									style={{
										background: 'rgba(255,255,255,0.1)',
										border: '1px solid rgba(255,255,255,0.2)',
										color: '#ffffff'
									}}
								>
									카드 보기
								</Button>
								<Button
									size="small"
									onClick={() => setUseEnhanced(true)}
									style={{
										background: 'rgba(255,255,255,0.1)',
										border: '1px solid rgba(255,255,255,0.2)',
										color: '#ffffff'
									}}
								>
									향상된 테이블
								</Button>
							</Space>
						</div>
						<div style={{ color: '#ffffff', textAlign: 'center', padding: '40px 0' }}>
							기본 테이블은 TableAPI를 제거했습니다. 카드 보기나 향상된 테이블을 이용해주세요.
						</div>
					</div>
				)}
			</StyledContent>
			<SendModal />
		</StyledLayout>
	)
}
